var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36,0.9C16.6,0.9,0.9,16.6,0.9,36S16.6,71.1,36,71.1S71.1,55.4,71.1,36S55.4,0.9,36,0.9z M50.2,31.6c0,1.1-0.9,2-2,2h-8.8 c-1.1,0-2-0.9-2-2s0.9-2,2-2h3.9c-1.8-2.4-4.7-3.9-7.8-3.9c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8c2.1,0,4.2-0.7,5.9-2 c0.9-0.6,2.1-0.5,2.8,0.4c0.7,0.9,0.5,2.1-0.4,2.8c-2.4,1.8-5.2,2.8-8.2,2.8c-7.6,0-13.7-6.2-13.7-13.7s6.2-13.7,13.7-13.7 c4.2,0,8.2,2,10.8,5.3v-4.3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2V31.6z"
});

function SvgIconRestoreUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000139272031033397369170000016578193759797485444_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestoreUser);
export default __webpack_public_path__ + "static/media/icon_restoreUser.e5500d4d.svg";
export { ForwardRef as ReactComponent };